import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'column-bar-graph',
    templateUrl: './column-bar-graph.component.html',
    styleUrls: ['./column-bar-graph.component.scss'],
})
export class ColumnBarGraphComponent implements OnInit {
    @Input() percent: number = 0;
    @Input() value: number = 0;

    @Input() format: string;
    formatValues: string[] = ['default', 'number', 'currency', 'percent'];

    constructor() {}

    ngOnInit() {
        if (!this.formatValues.includes(this.format)) {
            this.format = 'default';
        }
    }
}
